import { PropAsset } from './PropAsset';

// Torch - Meşale (Canvas2D animated)
export class Torch extends PropAsset {
  readonly id = 'torch';
  readonly width = 16;
  readonly height = 45;
  readonly walkable = true;  // Thin post, can walk past
  readonly collisionRadius = 0;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Flame glow circle - warm light radius around the torch
    const time = Date.now() * 0.004;
    const glowPulse = Math.sin(time * 2.5) * 0.04 + 0.96;
    const glowRadius = 22 * s * glowPulse;
    const gradient = ctx.createRadialGradient(
      cx, cy - 36 * s, 0,
      cx, cy - 36 * s, glowRadius
    );
    gradient.addColorStop(0, 'rgba(255,150,50,0.25)');
    gradient.addColorStop(0.5, 'rgba(255,100,30,0.1)');
    gradient.addColorStop(1, 'rgba(255,80,20,0)');
    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.arc(cx, cy - 36 * s, glowRadius, 0, Math.PI * 2);
    ctx.fill();

    // Small glow halo - Parıltı efekti
    ctx.fillStyle = 'rgba(255,150,50,0.2)';
    ctx.beginPath();
    ctx.arc(cx, cy - 32 * s, 12 * s, 0, Math.PI * 2);
    ctx.fill();

    // Pole - Sap
    ctx.fillStyle = '#4a3628';
    ctx.fillRect(cx - 2 * s, cy - 28 * s, 4 * s, 28 * s);

    // Torch head - Meşale başı
    ctx.fillStyle = '#3a2a1a';
    ctx.fillRect(cx - 3 * s, cy - 32 * s, 6 * s, 6 * s);

    // Outer flame - Dış alev
    ctx.fillStyle = '#ff6600';
    ctx.beginPath();
    ctx.moveTo(cx, cy - 45 * s);
    ctx.quadraticCurveTo(cx - 6 * s, cy - 38 * s, cx - 5 * s, cy - 30 * s);
    ctx.quadraticCurveTo(cx, cy - 33 * s, cx + 5 * s, cy - 30 * s);
    ctx.quadraticCurveTo(cx + 6 * s, cy - 38 * s, cx, cy - 45 * s);
    ctx.fill();

    // Inner flame - İç alev
    ctx.fillStyle = '#ffaa00';
    ctx.beginPath();
    ctx.moveTo(cx, cy - 40 * s);
    ctx.quadraticCurveTo(cx - 3 * s, cy - 35 * s, cx - 3 * s, cy - 30 * s);
    ctx.quadraticCurveTo(cx, cy - 32 * s, cx + 3 * s, cy - 30 * s);
    ctx.quadraticCurveTo(cx + 3 * s, cy - 35 * s, cx, cy - 40 * s);
    ctx.fill();

    // Core flame - Çekirdek alev
    ctx.fillStyle = '#ffff66';
    ctx.beginPath();
    ctx.moveTo(cx, cy - 36 * s);
    ctx.quadraticCurveTo(cx - 1.5 * s, cy - 33 * s, cx - 1.5 * s, cy - 30 * s);
    ctx.quadraticCurveTo(cx, cy - 31 * s, cx + 1.5 * s, cy - 30 * s);
    ctx.quadraticCurveTo(cx + 1.5 * s, cy - 33 * s, cx, cy - 36 * s);
    ctx.fill();
  }
}
